import React from 'react'
import { Grid, Button, Typography, Box, Link } from "@mui/material";
import { useState } from "react";
import OtpInput from "react-otp-input";
import logoImage from "../assets/logo/Frame 37680.svg";

function DeactivateResult() {
  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100vh"
      bgcolor={"#fff"}
      display="flex"
      justifyContent={"center"}
      alignItems="center"
      fontFamily="VazirMedium"
      position="relative"
    >
      <Box
        container
        xs={4}
        bgcolor="#FAFAFA"
        borderRadius={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        py={{xs:1,sm:2,md:4}}
        px={{xs:1,sm:4,md:6}}
      >
        <img src={logoImage} alt="logo" />
        <Typography variant="h1" fontWeight={600} mt={3} >.حساب کاربری شما غیر فعال شد</Typography>
        <Typography variant="h2" fontWeight={400} mt={3}>.به امید دیدار</Typography>
        </Box>
        </Grid>
  )
}

export default DeactivateResult